import { defineMessages } from 'react-intl';

export const scope = 'ai_apps';

export default defineMessages({
    delete_check: {
        id: `${scope}.delete_check`,
        defaultMessage: 'Are you sure you want to delete this AI app?',
    },
    delete_error: {
        id: `${scope}.delete_error`,
        defaultMessage: 'Error deleting app. Please try again.',
    },
    delete_success: {
        id: `${scope}.delete_success`,
        defaultMessage: 'App deleted successfully.',
    },
    credit_error: {
        id: `${scope}.credit_error`,
        defaultMessage: 'Your credits have run out. Please add credits.',
    },
    lauch_error: {
        id: `${scope}.lauch_error`,
        defaultMessage: 'Failed to launch app. Please try again.',
    },
});
